<template>
<div>
<request-status :request='invoicesRequest' :message200='false' />
<v-toolbar dense flat >
    <v-menu class='visible-xs-only' offset-y>
      <v-btn icon slot="activator"><v-icon>more_vert</v-icon></v-btn>
      <v-list subheader class="pa-0" >
        <v-subheader>Views</v-subheader>
        <v-divider></v-divider>

        <v-list-tile @click='$emit("setmain", "kanban")' >
          <v-list-tile-action ><v-icon>view_week</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Progress</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile to='/financials/' >
          <v-list-tile-action ><v-icon>account_balance_wallet</v-icon></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title >
                Statement
              </v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click='$emit("setmain", "overdueReport")'  >
          <v-list-tile-action ><v-icon>alarm_on</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Past due</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-list-tile @click='$emit("setmain", "overviewReport")' >
            <v-list-tile-title>Overview</v-list-tile-title>
          </v-list-tile> -->
        <v-list-tile to="/transactions" >
          <v-list-tile-action ><v-icon>paid</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Payments
            </v-list-tile-title>
          </v-list-tile-content>
          </v-list-tile>
        <v-subheader>
          Bulk actions</v-subheader>
        <v-divider></v-divider>
        <!-- <v-list-tile @click='$emit("setmain", "masterDetail")' >
          <v-list-tile-title>
            <v-icon>assignment_turned_in</v-icon>
            {{ $t('bulk.appointmentsTodo') }}</v-list-tile-title>
        </v-list-tile> -->
        <v-list-tile @click='$emit("setmain", "gallery")' >
          <v-list-tile-action ><v-icon>done_all</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t('bulk.invoiceable') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>

  <!-- <v-toolbar-title>{{title}}</v-toolbar-title> -->
      <!-- <v-btn class='hidden-xs-only' @click='$emit("setmain", "kanban")' icon ><v-icon>view_week</v-icon></v-btn>
      <v-btn class='hidden-xs-only' @click='$emit("setmain", "table")' icon ><v-icon>table_chart</v-icon></v-btn>
      <v-menu bottom left class='hidden-xs-only' >
        <v-btn slot="activator" icon >
          <v-icon>show_chart</v-icon>
        </v-btn>
        <v-list dense>
          <!-- <v-list-tile @click='$emit("setmain", "overviewReport")' >
            <v-list-tile-title>Overview</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to='/financials/' >
            <v-list-tile-title>Statement</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click='$emit("setmain", "transactions")' >
            <v-list-tile-title>Payments</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click='$emit("setmain", "overdueReport")'  >
            <v-list-tile-title>Past due</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> -->

  <!-- <v-spacer></v-spacer> -->
  <template>
    <v-btn @click='$emit("reload")' :loading='invoicesRequest.loading' icon ><v-icon>replay</v-icon></v-btn>

    <v-menu :close-on-content-click='false' v-model='showFilters' >
      <template v-slot:activator="{ on }">
      <v-btn v-on='on' slot='activator' icon >
        <v-icon>filter_list</v-icon>
      </v-btn>
      </template>
      <invoice-filter
        :facets='facets'
        :params.sync='params'
        @close='showFilters=false' >

        <v-switch hide-messages dense
          v-model="localUseDateDue"
          :label="dateTypeString" >
        </v-switch>

      </invoice-filter>
    </v-menu>

    <v-btn small outline color='primary'
      @click='$store.dispatch("ACTIVATE_RANGE_PICKER")' >
      <v-icon small class='hidden-xs-only' >event</v-icon>
      <v-divider vertical class='mx-2 hidden-xs-only' />
      {{ $tc('title.summary', totalItems, summaryParams) }}
    </v-btn>

    <v-spacer/>
    <v-text-field class='hidden-xs-only mx-3'
      placeholder='Search on invoice number, payment reference, or invoice title'
      v-if='withSearch'
      v-model='searchString'
      clearable
      @input='debouncedSearch'
      @keyup.esc='searchString="";debouncedSearch()'
      prepend-icon='search' />

    <template v-if='showServerSearch' >
      <v-btn v-if='serverSearch' @click='searchOnServer' flat small outline >Search</v-btn>
      <v-checkbox flat hide-messages dense small
        v-if='searchString && searchString.length > 2'
        v-model='serverSearch'
        class='hidden-xs-only caption pt-4'
        label='Search on server' />
    </template>

    <v-btn dark
      :fab='$vuetify.breakpoint.xs'
      :small='$vuetify.breakpoint.xs'
      @click='launchInvoiceDialog({touchClear: Math.random()})'
      color='primary' >
      <v-icon dark>add</v-icon>
      <span class='hidden-xs-only'>New Invoice</span>
    </v-btn>

  </template>
  <!-- <v-spacer></v-spacer> -->
  <!-- <v-menu class='hidden-xs-only' bottom left>
    <v-btn slot="activator" flat >
      Bulk <v-icon>expand_more</v-icon>
    </v-btn>
    <v-list dense>
      <v-list-tile @click='$emit("setmain", "masterDetail")' >
        <v-list-tile-title>{{ $t('bulk.appointmentsTodo') }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click='$emit("setmain", "gallery")' >
        <v-list-tile-title>{{ $t('bulk.invoiceable') }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu> -->

  <!-- <v-btn icon><v-icon>filter_list</v-icon></v-btn> -->
  <!-- <v-btn
    @click="launchInvoiceSettingsDialog({touch: Math.random()})"
    icon><v-icon>settings</v-icon></v-btn> -->

  <!-- <v-progress-circular indeterminate color='amber' :width="3" small v-if='invoicesRequest.loading' icon ></v-progress-circular>
  <v-btn v-else @click='loadInvoices()' icon ><v-icon>replay</v-icon></v-btn> -->

  <v-layout slot="extension"  >
    <slot name='extra-nav'></slot>
    <!-- <v-flex class='text-xs-right mt-2' > -->
    <span class='mt-2' >
      {{totalItems}} invoices found
    </span>
    <v-spacer></v-spacer>

    <template v-if='page && totalPages > 1' >
      <v-btn icon small
        :disabled='page <= 1'
        @click='$emit("update:page", (page - 1))' >
        <v-icon >chevron_left</v-icon></v-btn>
        <span class='mt-2' >{{page}} of {{totalPages}}</span>
      <v-btn icon small
        :disabled='page === totalPages'
        @click='$emit("update:page", (page + 1))' >
        <v-icon >chevron_right</v-icon></v-btn>
    </template>

  </v-layout>


</v-toolbar>
</div>
</template>

<script>
import {LIST_INVOICES_IN_RANGE_REQ} from '@/store/constants'
import InvoiceFilter from '@/components/invoice/InvoiceFilter.vue'
export default {
  name: 'InvoiceToolbar',
  components: {InvoiceFilter},
  props: {
    title: {type: String},
    withSearch: { type: Boolean, default: false },
    useDateDue: { type: Boolean, default: false },
    page: { type: Number, default: 1 }
  },
  data () {
    return {
      localUseDateDue: false,
      showFilters: false,
      serverSearch: true,
      activetab: '',
      searchString: '',
      debouncedSearchString: '',
      timeout: null,
      loadingReqId: LIST_INVOICES_IN_RANGE_REQ,
      params: {}
    }
  },
  mounted () {
    this.localUseDateDue = this.useDateDue
  },
  computed: {
    activeDateRange () {
      return this.$store.getters.activeDateRange
    },
    formattedDateRange () {
      return {
        fromDate: this.dateformat(this.activeDateRange.from, 'Do MMM'),
        toDate: this.dateformat(this.activeDateRange.to, 'Do MMM YYYY')
      }
    },
    invoicesRequest () {
      return this.$store.getters.getRequestById(LIST_INVOICES_IN_RANGE_REQ, true)
    },
    totalItems () {
      return this.getObjectPath(this.invoicesRequest, 'result.data.count', 0)
    },
    totalPages () {
      let pagesize = this.invoices.length
      if (pagesize === 0) { return 1 }
      return Math.ceil(this.totalItems / pagesize)
    },
    summaryParams () {
      let data = this.formattedDateRange
      data['total'] = this.totalItems
      return data
    },
    facets () {
      return this.getObjectPath(this.invoicesRequest, 'result.data.facets', {})
    },
    invoices () {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', [])
    },
    showServerSearch () {
      return (this.searchString && this.searchString.length > 2)
    },
    dateTypeString () {
      if (this.localUseDateDue) { return 'Search using due date' }
      return 'Search using invoice date'
    }
  },
  watch: {
    params () {
      this.loadInvoices('due', this.params)
    },
    showServerSearch () {
      if (!this.showServerSearch) { this.serverSearch = false }
    },
    serverSearch () {
      if (this.serverSearch === true) {
        this.searchOnServer
      } else {
        this.searchString = null
        this.loadInvoices()
        this.debouncedSearch()
      }
    },
    localUseDateDue () {
      console.log(this.localUseDateDue)
      this.$emit('update:useDateDue', this.localUseDateDue)
    }
  },
  methods: {
    debouncedSearch () {
      if (this.serverSearch) { return }
      if (this.timeout) {
        window.clearTimeout(this.timeout)
      }
      this.timeout = window.setTimeout(() => {
        this.$emit('search', this.searchString)
      }, 300)
    },
    searchOnServer () {
      this.$emit('search', null)
      this.loadInvoices('due', {search: this.searchString})
    }
  },
  i18n: {
    messages: {
      en: {
        title: {
          // summary: 'No invoices from {fromDate} to {toDate} | One invoice from {fromDate} to {toDate} | {total} invoices from {fromDate} to {toDate}'
          summary: '{fromDate} to {toDate}'
        },
        bulk: {
          appointmentsTodo: 'Appointment maintenance',
          invoiceable: 'Invoiceable clients',
          status: 'Filter By Status'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Toolbar.vue?405d7583